import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toArray from "@babel/runtime/helpers/toArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * A simple translator hook that supports React node replacements.
 *
 * Designed to be used with JSON-based locale files that mirror those used in the Milanote app.
 */

import React from 'react';
var _replacer = function replacer(input, replacements) {
  var _replacements = _toArray(replacements),
    nextReplacement = _replacements[0],
    queued = _arrayLikeToArray(_replacements).slice(1);
  if (!nextReplacement) return input;
  var output = input.map(function (node, index) {
    if (typeof node !== 'string') return node;
    var parts = node.split(new RegExp("</?".concat(nextReplacement.key, ">")));
    if (parts.length === 1) return node;
    var _parts = _slicedToArray(parts, 3),
      before = _parts[0],
      replacement = _parts[1],
      after = _parts[2];
    if (nextReplacement.key === 'and') {
      return [before, 'and', after];
    }
    var withChildren = /*#__PURE__*/React.cloneElement(nextReplacement.replacement, {
      key: "replacement-".concat(index)
    }, replacement);
    return [before, withChildren, after].filter(function (part) {
      return part !== '';
    });
  }).flat();
  return _replacer(output, queued);
};
var translator = function translator(strings) {
  return function (key, _context, options) {
    // traverse object based on dot notation keys
    var keys = key.split('.');
    var result = strings;
    var _iterator = _createForOfIteratorHelper(keys),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _result;
        var k = _step.value;
        result = (_result = result) === null || _result === void 0 ? void 0 : _result[k];
        if (result === undefined) break;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    var text = typeof result === 'string' ? result : key;
    if (!(options !== null && options !== void 0 && options.components)) return text;
    var replacements = Object.entries(options.components).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        replacement = _ref2[1];
      return {
        key: key,
        replacement: replacement
      };
    });
    return _replacer([text], replacements);
  };
};
export var useTranslator = function useTranslator(strings) {
  return translator(strings);
};